module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-loader"
  }, [_c('Loader')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ab5524b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/loader.vue
// module id = 2041
// module chunks = 2